import { render, staticRenderFns } from "./ExternalTicketList.vue?vue&type=template&id=45a96df8&"
import script from "./ExternalTicketList.vue?vue&type=script&lang=js&"
export * from "./ExternalTicketList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports